import { createApp } from 'vue'
import App from './App.vue'
import { Tab, Tabs, Button } from 'vant';


import 'vant/lib/index.css';
import "./assets/css/main.css";

const app=createApp(App)

app.use(Tab);
app.use(Tabs);
app.use(Button);

app.mount('#app')

